// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qbh0","delete":"styles_delete__18N71","update":"styles_update__2hfiW","add":"styles_add__1wIiQ"};